import React from "react";
import { connect } from "react-redux";

import { isPaymentsReady } from "state/school_money/selectors";
import { markStudentPaymentsAsSeen } from "state/school_money/actions";

import Preloader from "components/school_money/Preloader";
import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import StudentPaymentList from "components/school_money/payments/StudentPaymentList";

import "./PaymentsPage.css";

class PaymentsPage extends React.Component {

  generatePath(studentID) {
    return `/school_money/payments/${studentID}/`;
  }

  isPaymentsReady = (state) => {
    return isPaymentsReady(state, this.props.studentID);
  }

  onStudentChange = (studentID, prevStudentID) => {
    this.props.markStudentPaymentsAsSeen(prevStudentID);
  }

  componentWillUnmount() {
    this.props.markStudentPaymentsAsSeen(this.props.match.params.studentID);
  }

  render() {
    const { studentID } = this.props.match.params;
    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isPaymentsReady}>
          <div className="payments-page">
            <div className="page-header">
              <h1 className="page-header__title">Payments</h1>
              <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
            </div>
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath} onChange={this.onStudentChange}>
              { studentID => <StudentPaymentList key={studentID} studentID={studentID} /> }
            </StudentCarousel>
          </div>
        </Preloader>
      </MaintainValidStudentID>
    )
  }

}

export default connect(
  undefined,
  { markStudentPaymentsAsSeen }
)(PaymentsPage);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/PaymentsPage.js